<template>
     <transition :name="transitionName">
       <router-view class="child-view"></router-view>
     </transition>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  mounted () {
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果 
  watch: {
    '$route' (to, from) {
      if(to.meta.index>from.meta.index){
        this.transitionName = 'slide-left';
      }else{
        this.transitionName = 'slide-right';
      }
    }
  }
}
</script>

<style>
.child-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all .5s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(80px, 0);
  transform: translate(80px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-80px, 0);
  transform: translate(-80px, 0);
}
</style>


// WEBPACK FOOTER //
// src/App.vue